import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
// Filter out noisy third-party errors in development
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  const originalWarn = console.warn;
  console.error = (...args: any[]) => {
    const errorString = args.join(' ');
    // Filter out known harmless errors
    if (errorString.includes('cloudflareinsights') || errorString.includes('clarity.ms') || errorString.includes('googletagmanager') || errorString.includes('ERR_BLOCKED_BY_CONTENT_BLOCKER') || errorString.includes('sendObjectBeacon') || errorString.includes('web-api.tp.entsoe.eu') || errorString.includes('allorigins.win') || errorString.includes('CORS')) {
      return; // Silently ignore
    }
    originalError.apply(console, args);
  };
  console.warn = (...args: any[]) => {
    const warnString = args.join(' ');
    // Filter out known harmless warnings
    if (warnString.includes('ENTSO-E') || warnString.includes('using generated data')) {
      return; // Silently ignore
    }
    originalWarn.apply(console, args);
  };
}
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode data-id="element-3617">
    <App data-id="element-3618" />
  </React.StrictMode>);